(function () {
  function createTooltipElement() {
    const tooltip = document.createElement("div");
    tooltip.className = "custom-tooltip custom-tooltip--debug"; // clase persistente
    tooltip.style.display = "block"; // forzamos el block para inspección
    tooltip.innerHTML = "";
    document.body.appendChild(tooltip);
    return tooltip;
  }

  function showTooltip(label, text, target) {
    tooltip.innerHTML = `<strong>${label}</strong><br>${text}`;
    const iconRect = target.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();

    const scrollTop = window.scrollY || window.pageYOffset;
    const scrollLeft = window.scrollX || window.pageXOffset;

    // Posición base: debajo del icono
    let top = iconRect.bottom + scrollTop + 4; // 8px de margen
    let left = iconRect.left + scrollLeft;

    // Si el tooltip se sale por la derecha del viewport, lo alineamos al borde derecho del icono o lo desplazamos
    const tooltipWidth = tooltip.offsetWidth;
    const viewportWidth = document.documentElement.clientWidth;

    if (left + tooltipWidth > viewportWidth - 10) {
      left = Math.max(viewportWidth - tooltipWidth - 10, scrollLeft + 10); // mínimo 10px de margen izquierdo
    }

    tooltip.style.top = `${top}px`;
    tooltip.style.left = `${left}px`;
    const arrowLeft = iconRect.left + iconRect.width / 2 - left + scrollX - 5;
    tooltip.style.setProperty("--arrow-left", `${arrowLeft}px`);

    tooltip.classList.add("visible");
  }

  function hideTooltip() {
    tooltip.classList.remove("visible");
  }

  const tooltip = createTooltipElement();
  const icons = document.querySelectorAll(".product-desc-section__icon");

  // Ocultar tooltip si se hace click fuera
  document.addEventListener("click", function (e) {
    if (
      !tooltip.contains(e.target) &&
      !e.target.classList.contains("product-desc-section__icon")
    ) {
      hideTooltip();
    }
  });

  icons.forEach((img) => {
    const iconName = img.dataset.iconName?.trim();
    const label = img.dataset.iconLabel?.trim();
    if (!iconName || !iconTooltips[iconName] || !titleTooltips[iconName]) return;

    img.addEventListener("click", (e) => {
      e.stopPropagation(); // Evita que el click cierre el tooltip justo después de abrirlo

      const isVisible = tooltip.classList.contains("visible");
      const isSameIcon =
        tooltip.innerHTML ===
        `<strong>${titleTooltips[iconName]}</strong><br>${iconTooltips[iconName]}`;

      if (isVisible && isSameIcon) {
        hideTooltip(); // Cierra si es el mismo icono
      } else {
        showTooltip(titleTooltips[iconName], iconTooltips[iconName], img);
      }
    });
  });

  window.addEventListener("load", () => {
    const firstIcon = Array.from(icons).find((img) => {
      const iconName = img.dataset.iconName?.trim();
      return iconName && iconTooltips[iconName];
    });

    if (firstIcon) {
      const label = firstIcon.dataset.iconLabel?.trim();
      const iconName = firstIcon.dataset.iconName?.trim();

      if (firstIcon.complete) {
        showTooltip(label, iconTooltips[iconName], firstIcon);
      } else {
        firstIcon.addEventListener("load", () => {
          showTooltip(label, iconTooltips[iconName], firstIcon);
        });
      }
    }
  });
})();
